import AuthorizationHelper from '@auth/services/authorization.helper';
import ModulesHelper from '@core/services/modules.helper';

export const subventionsRoutes = [
  {
    path: 'article-true-costs',
    name: 'admin-article-true-costs',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.article_true_costs],
      module: ModulesHelper.SUBVENTIONS_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-article-true-costs" */ '@subventions/pages/article-true-costs/article-true-costs.vue'
      ),
  },
];
